const inputDefault = {

}

export const inputLite = {
    ...inputDefault,
}

export const inputDark = {
    ...inputDefault,
}